export function fetchInitSingle() {
  return {
    isFetched: false,
    isFetching: false,
    fetchError: null,
    fetchCode: null,
    data: null,
  };
}

export async function fetchSingle(callback, context, mutation) {
  context.commit(mutation, { ...fetchInitSingle(), isFetching: true });
  try {
    context.commit(mutation, { ...fetchInitSingle(), isFetched: true, data: await callback() });
  } catch (e) {
    context.commit(mutation, {
      ...fetchInitSingle(),
      isFetched: true,
      fetchError: e.message,
      fetchCode: e.code,
    });
  }
}

export function fetchInitCollection() {
  return {
    isFetched: false,
    isFetching: false,
    fetchError: null,
    fetchCode: null,
    items: [],
  };
}

export async function fetchCollection(callback, context, mutation) {
  context.commit(mutation, { ...fetchInitCollection(), isFetching: true });
  try {
    context.commit(mutation, {
      ...fetchInitCollection(),
      isFetched: true,
      items: await callback(),
    });
  } catch (e) {
    context.commit(mutation, {
      ...fetchInitCollection(),
      isFetched: true,
      fetchError: e.message,
      fetchCode: e.code,
    });
  }
}
